import { getAllSubjectsTimepointsStudiesStudyIdSubjectsTimepointsGet } from '@common/config/api/client'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { SubjectsTimepointsParams } from '../types'

export const useGetSubjectsList = (
  queryKey: string[],
  params: SubjectsTimepointsParams,
  options?: Partial<UseQueryOptions>,
) => {
  return useQuery({
    queryKey: [...queryKey, params],
    queryFn: () =>
      getAllSubjectsTimepointsStudiesStudyIdSubjectsTimepointsGet({
        path: {
          study_id: params.study_id,
        },
        query: {
          limit: params.limit,
          next_cursor: params.next_cursor,
          previous_cursor: params.previous_cursor,
          search: params.search,
          order_by_field: params.order_by_field,
          asc_order: params.asc_order,
        },
      }),
    enabled: !!params.study_id && options?.enabled !== false,
  })
}
